import moment from "moment";

const intervals = [
    { duration: 60 * 60 },
    { duration: 24 * 60 * 60, timebucket: "hour" },
    { duration: 7 * 24 * 60 * 60, timebucket: "hour" },
    { duration: 30 * 24 * 60 * 60, timebucket: "day" },
    { duration: 365 * 24 * 60 * 60, timebucket: "day" }
];

export const getTimetParamsFromWidgetConfig = (widgetConfig = {}) => {
    const { widgetSettings = {} } = widgetConfig;
    const interval = Number(widgetSettings.interval);
    const selected = Number.isInteger(interval) && intervals[interval]
        ? intervals[interval] : intervals[0];
    const end = Math.floor(moment.utc().valueOf() / 1000);
    return {
        begin: end - selected.duration,
        end,
        // A bounded diagram needs all rows in its displayed time range.
        limit: 0,
        timebucket: selected.timebucket,
        bucketoffset: selected.timebucket === "day"
            ? new Date().getTimezoneOffset() * 60 : undefined
    };
};

export const getHistoQueryString = (widgetConfig) => {
    const { begin, end, timebucket, bucketoffset } = getTimetParamsFromWidgetConfig(widgetConfig);
    const params = [["begin", begin], ["end", end]];
    if (timebucket) params.push(["time_bucket", timebucket]);
    if (bucketoffset !== undefined) params.push(["bucket_offset", bucketoffset]);
    return "?" + params.map(([key, value]) => key + "=" + encodeURIComponent(value)).join("&");
};
